// client/src/services/peaService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';
const baseUrl = `${apiUrl}/investments/pea`;

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

// Remonte le message d'erreur du serveur quand il y en a un.
const handle = async (response, fallback) => {
  checkUnauthorized(response);
  const result = await response.json().catch(() => null);
  if (!response.ok) throw new Error((result && result.message) || fallback);
  return result;
};

const getOverview = async () => {
  const response = await fetch(`${baseUrl}/overview`, { headers: authHeaders() });
  return handle(response, 'Erreur lors du chargement des investissements.');
};

const getAccounts = async () => {
  const response = await fetch(`${baseUrl}/accounts`, { headers: authHeaders() });
  return handle(response, 'Erreur lors du chargement des comptes PEA.');
};

const createAccount = async (data) => {
  const response = await fetch(`${baseUrl}/accounts`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  return handle(response, 'Erreur lors de la création du compte PEA.');
};

const updateAccount = async (id, data) => {
  const response = await fetch(`${baseUrl}/accounts/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  return handle(response, 'Erreur lors de la mise à jour du compte PEA.');
};

const deleteAccount = async (id) => {
  const response = await fetch(`${baseUrl}/accounts/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  return handle(response, 'Erreur lors de la suppression du compte PEA.');
};

const deletePosition = async (id) => {
  const response = await fetch(`${baseUrl}/positions/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  return handle(response, 'Erreur lors de la suppression de la ligne.');
};

// L'export du courtier est envoyé en multipart, comme l'import de relevés.
const importPortfolio = async (accountId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`${baseUrl}/accounts/${accountId}/import`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData
  });
  return handle(response, "Erreur lors de l'import du portefeuille.");
};

const peaService = {
  getOverview,
  getAccounts,
  createAccount,
  updateAccount,
  deleteAccount,
  deletePosition,
  importPortfolio
};

export default peaService;
